var exports = {
  "H": "x93eb46d8--8bea4c--week",
};

module.exports = exports;
